import Footer from '@pyt/ui/widgets/footer'
import { useAmp } from 'next/amp'
import { useContext, useState } from 'react'

import { AppConfig } from '../../app-config'
import AppContext from '../../store/AppContext'
import getWebsiteContactEmail from '../../utils/getWebsiteContactEmail'
import getWebsiteContactNumber from '../../utils/getWebsiteContactNumber'
import getWebsiteWhatsAppNumber from '../../utils/getWebsiteWhatsAppNumber'
import {
	EVENT_CHAT_REQUESTED,
	EVENT_FOOTER_DESTINATION_CLICK,
	SUBSCRIBE,
	trackEvent,
} from '../../utils/ML/EventsTracker'
import DotList from './dotList'

export function validateEmail(email) {
	var re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email)
}

const FooterWrapper = ({
	footerData,
	actions = {
		fetchFooterData: () => {},
	},
	openChatWidget,
	showContactNumber,
	pathname,
}) => {
	const isAmp = useAmp()
	const [email, setEmail] = useState('')
	const [{ locale }] = useContext(AppContext)

	const trackers = {
		ABOUT: 'n-tracker-footer-about',
		CAREERS: 'n-tracker-footer-careers',
		BLOG: 'n-tracker-footer-blog',
		TESTIMONIALS: 'n-tracker-footer-testimonials',
		GUIDES: 'n-tracker-footer-guides',
		VISA: 'n-tracker-footer-visa',
		PRESS: 'n-tracker-footer-press',
		FAQ: 'n-tracker-footer-faq',
		TERMS: 'n-tracker-footer-terms',
		PRIVACY: 'n-tracker-footer-privacy',
		CANCELLATIONS: 'n-tracker-footer-cancellations',
		SITEMAP: 'n-tracker-footer-sitemap',
		CONTACT_US: 'n-tracker-footer-contactus',
		FACEBOOK: 'n-tracker-footer-facebookicon',
		TWITTER: 'n-tracker-footer-twittericon',
		INSTAGRAM: 'n-tracker-footer-instagramicon',
		LINKEDIN: 'n-tracker-footer-linkedin',
		TALK_TO_AN_EXPERT: 'n-tracker-talktoanexpert',
	}

	const scrollTop = (destination_name, takeToTop = false) => {
		if (takeToTop) {
			window.scroll(0, 0)
		}

		if (destination_name) {
			trackEvent(EVENT_FOOTER_DESTINATION_CLICK, {
				destination_name,
			})
		}
	}

	const handleChange = event => {
		setEmail(event.target.value)
	}

	const handleEmailSubmit = (e, setTboxState) => {
		let apiUrl = `${AppConfig.api_url}user/subscribe`
		const headers = new Headers({
			'Content-Type': 'application/json',
		})
		let requestDetails = {
			method: 'POST',
			headers,
			mode: 'cors',
		}
		e.preventDefault()
		const data_str = JSON.stringify({ email: email })
		const $signupSuccess = document.querySelector('.ftr-success')
		const $signupEmailInput = document.querySelector('#ftrEmailInput')

		if (email === '') {
			setTboxState('has-error')
		} else {
			if (validateEmail(email)) {
				setTboxState('success')
				requestDetails.body = data_str
				fetch(apiUrl, requestDetails)
					.then(() => {
						trackEvent(SUBSCRIBE, {
							email: email,
						})
						$signupEmailInput.value = ''
						setTimeout(function () {
							setTboxState()
						}, 10 * 1000)
					})
					.catch(() => {
						$signupEmailInput.value = ''
						$signupSuccess.text =
							'Hey thank you but seems like you are already on our list!'
						$signupSuccess.style.opacity = '1'
						setTimeout(function () {
							$signupSuccess.style.opacity = '0'
						}, 10 * 1000)
					})
			} else {
				setTboxState('has-error')
			}
		}
	}

	const footerProps = {
		footerData,
		actions,
		openChatWidget,
		showContactNumber,
		pathname,
		hideEmailForm: isAmp,
		handlers: {
			scrollTop,
			handleChange,
			handleEmailSubmit,
		},
		trackers,
		helpers: {
			events: {
				trackEvent,
				EVENT_CHAT_REQUESTED,
				SUBSCRIBE,
			},
			getWebsiteContactEmail: () => getWebsiteContactEmail(locale),
			getWebsiteContactNumber: () => getWebsiteContactNumber(locale),
			getWebsiteWhatsAppNumber: () => getWebsiteWhatsAppNumber(locale),
			MALDIVES_ROUTES: {},
		},
		appConfig: AppConfig,
		DotList,
	}

	return <Footer {...footerProps} />
}

export default FooterWrapper
